import { bindable, autoinject } from 'aurelia-framework';
import { EntityController } from '../../entity-controller';

@autoinject()
export class FileWidget {


	constructor(private controller: EntityController) {
	}

	@bindable item;
	@bindable save: Function;
	@bindable validate: Function;
	showEditContent = false;
	showEditIcon = true;
	showSaveIcon = false;
	//showIcons = false;
	edit() {
		this.showEditContent = true;
		this.showSaveIcon = true;
		this.showEditIcon = false;
	}

	confirmDelete() {
		this.controller.confirmDeleteFile(this.item);
	}

	saveEdit() {
		// if (this.validate()) {
		this.controller.updateAttachment(this.item);
			this.showEditContent = false;
			this.showEditIcon = true;
			this.showSaveIcon = false;
		// }
	}
}
